export default "__VITE_ASSET__7hv4kHTN__"